import { ResourceService } from "../ResourceService/resource.service"
import { ResourceDelegate } from "../ResourceService/resource.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class ResourceServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): ResourceService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new ResourceDelegate(config, httpProvider);

        return new ResourceService(delegate, authenticationService);
    }
}